// Field Tab Definitions - Options match BookingForm.js exactly (lowercase)
export const FIELD_TABS = [
  {
    id: 'rto_registration',
    label: 'RTO & Registration',
    dateField: 'date_of_booking',
    fields: [
      { id: 'rto_paper_status', label: 'RTO Paper Status', type: 'select', options: ['pending', 'submitted', 'completed'] },
      { id: 'rc_status', label: 'RC Status', type: 'select', options: ['pending', 'applied', 'received'] },
    ]
  },
  {
    id: 'hsrp',
    label: 'HSRP',
    dateField: 'date_of_booking',
    fields: [
      { id: 'hsrp_number_plate', label: 'HSRP Number Plate', type: 'select', options: ['pending', 'applied', 'received'] },
      { id: 'hsrp_received_informed', label: 'HSRP Received Informed', type: 'select', options: ['Yes', 'No'] },
      { id: 'hsrp_informed_date', label: 'HSRP Informed Date', type: 'date' },
    ]
  },
  {
    id: 'invoice_accounts',
    label: 'Invoice & Accounts',
    dateField: 'date_of_booking',
    fields: [
      { id: 'invoice_dms', label: 'Invoice DMS', type: 'select', options: ['', 'Yes', 'No'] },
      { id: 'tally_invoice', label: 'Tally Invoice', type: 'select', options: ['', 'Yes', 'No'] },
      { id: 'ledger_status', label: 'Ledger Status', type: 'select', options: ['pending', 'verified', 'cleared'] },
      { id: 'accounts_verified_by', label: 'Accounts Verified By', type: 'select', options: ['', 'Jr.Accountant', 'Sr.Accountant', 'Chief Accountant'] },
    ]
  },
  {
    id: 'discounts',
    label: 'Discounts',
    dateField: 'dms_invoice_date',
    fields: [
      { id: 'pool_amount', label: 'Pool Amount', type: 'number' },
      { id: 'scheme_discount_1', label: 'Scheme Discount 1', type: 'number' },
      { id: 'scheme_discount_2', label: 'Scheme Discount 2', type: 'number' },
      { id: 'special_discount', label: 'Special Discount', type: 'number' },
    ]
  },
  {
    id: 'other_status',
    label: 'Other Fields',
    dateField: 'date_of_booking',
    fields: [
      { id: 'inwards_status', label: 'Exchange Vehicle Inward Status', type: 'select', options: ['Inwards Pending', 'Inwards Done', 'Delivered'] },
      { id: 'address_proof_received', label: 'Address Proof Status', type: 'select', options: ['Pending', 'Received'] },
      { id: 'photos', label: 'Photo Status', type: 'select', options: ['Pending', 'Received'] },
      { id: 'loan_status', label: 'Loan Status', type: 'select', options: ['pending', 'approved', 'disbursed', 'rejected'] },
    ]
  },
  {
    id: 'pme',
    label: 'PME',
    dateField: 'date_of_booking',
    fields: [
      { id: 'pme_drive_no', label: 'PME Drive No.', type: 'text' },
      { id: 'pme_submission_date', label: 'PME Submission Date', type: 'date' },
      { id: 'pme_status', label: 'PME Status', type: 'select', options: ['pending', 'submitted', 'approved', 'rejected'] },
    ]
  },
  // iter-121: New "Additional Info" tab — Customer Address / Insurance / DMS.
  // 14 fields editable inline from Multi Reports without disturbing any
  // existing tab. Field keys match the bookings collection schema.
  {
    id: 'additional_info',
    label: 'Additional Info',
    dateField: 'date_of_booking',
    fields: [
      { id: 'building_name', label: 'Building Name', type: 'text' },
      { id: 'door_no', label: 'Door No.', type: 'text' },
      { id: 'address_1', label: 'Address Line 1', type: 'text' },
      { id: 'address_2', label: 'Address Line 2', type: 'text' },
      { id: 'address_3', label: 'Address Line 3', type: 'text' },
      { id: 'area', label: 'Area', type: 'text' },
      { id: 'city', label: 'City', type: 'text' },
      { id: 'state', label: 'State', type: 'text' },
      { id: 'pin_code', label: 'Pincode', type: 'text' },
      { id: 'insurance_company_name', label: 'Insurance Company', type: 'text' },
      { id: 'policy_no', label: 'Policy No.', type: 'text' },
      { id: 'own_damage_expiry_date', label: 'Own Damage Expiry Date', type: 'date' },
      { id: 'dms_invoice_no', label: 'DMS Invoice No.', type: 'text' },
      { id: 'dms_invoice_date', label: 'DMS Invoice Date', type: 'date' },
    ]
  },
];

// Additional display columns that can be shown/hidden (in user-requested order)
export const ADDITIONAL_COLUMNS = [
  { id: 'registration_number', label: '1. Registration Number', group: 'vehicle', default: true },
  { id: 'pme_drive_no', label: '2. PME Drive No', group: 'documents', default: true },
  { id: 'brand_model_color', label: '3. Brand, Model, Color', group: 'vehicle', default: true, computed: true },
  { id: 'whatsapp_no', label: '4. WhatsApp No', group: 'contact', default: false },
  { id: 'mobile_no_1', label: '5. Mobile No', group: 'contact', default: true },
  { id: 'email', label: '6. Email', group: 'contact', default: false },
  { id: 'date_of_registration', label: '7. Date of Registration', group: 'dates', default: false },
  { id: 'delivery_date', label: '8. Date of Delivery', group: 'dates', default: false },
  { id: 'dms_invoice_no', label: '9. DMS Invoice No', group: 'invoice', default: true },
  { id: 'dms_invoice_date', label: '10. DMS Invoice Date', group: 'invoice', default: true },
  { id: 'tally_invoice', label: '11. Tally Invoice', group: 'invoice', default: false },
  { id: 'customer_balance', label: '12. Customer Balance', group: 'finance', default: false },
  { id: 'ledger_status', label: '13. Ledger Status', group: 'finance', default: false },
  { id: 'exchange_vehicle_no', label: '14. Exchange Vehicle No', group: 'exchange', default: false },
  { id: 'exchange_vehicle_details', label: '15. Exchange Vehicle Brand, Model, Color', group: 'exchange', default: false, computed: true },
  { id: 'date_of_booking', label: '16. Booking Date', group: 'dates', default: true },
  { id: 'sales_representative', label: '17. Sales Representative', group: 'sales', default: true },
  { id: 'lead_source', label: '18. Lead Source', group: 'sales', default: false },
  { id: 'delivery_date_display', label: '19. Delivery Date', group: 'dates', default: false },
  { id: 'financier', label: '20. Financier', group: 'finance', default: false },
  { id: 'loan_status', label: '21. Loan Status', group: 'finance', default: false },
  { id: 'vendors_purchase_price', label: '22. Vendor Purchase Price', group: 'vendor', default: false },
];

// Column groups for better organization in selector
export const COLUMN_GROUPS = [
  { id: 'vehicle', label: 'Vehicle Info' },
  { id: 'contact', label: 'Contact Info' },
  { id: 'dates', label: 'Dates' },
  { id: 'invoice', label: 'Invoice & DMS' },
  { id: 'finance', label: 'Finance' },
  { id: 'exchange', label: 'Exchange Vehicle' },
  { id: 'sales', label: 'Sales' },
  { id: 'documents', label: 'Documents' },
  { id: 'vendor', label: 'Vendor' },
];

// Get current month date range
export const getCurrentMonthRange = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  
  const formatDateISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  
  return {
    from: formatDateISO(firstDay),
    to: formatDateISO(lastDay)
  };
};

// Helper to format date for display
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  } catch { return dateStr; }
};

// Get status badge color
export const getStatusBadge = (status) => {
  const statusLower = status?.toLowerCase();
  if (['received', 'completed', 'verified', 'approved', 'yes'].includes(statusLower)) {
    return 'bg-green-100 text-green-800';
  } else if (['applied', 'updated', 'submitted', 'finance'].includes(statusLower)) {
    return 'bg-yellow-100 text-yellow-800';
  }
  return 'bg-red-100 text-red-800';
};

// Tabs that have extra columns (Chassis No, Reg No, DMS Invoice No/Date)
export const TABS_WITH_EXTRA_COLUMNS = ['discounts', 'other_status', 'pme'];
